import { render } from "./OrderDetailsSkeleton.vue?vue&type=template&id=b2e1847a&scoped=true"
const script = {}

import "./OrderDetailsSkeleton.vue?vue&type=style&index=0&id=b2e1847a&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2e1847a"],['__file',"resources/js/components/whatsapp-managment/includes/Profile/OrderDetails/OrderDetailsSkeleton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b2e1847a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b2e1847a', __exports__)) {
    console.log('reload')
    api.reload('b2e1847a', __exports__)
  }
  
  module.hot.accept("./OrderDetailsSkeleton.vue?vue&type=template&id=b2e1847a&scoped=true", () => {
    console.log('re-render')
    api.rerender('b2e1847a', render)
  })

}


export default __exports__